/**
 * Helpers de formatacao do modulo Suprimentos.
 */

export const SITUACAO_REQ_LABEL = {
  RASCUNHO: "Rascunho",
  APROVADA: "Aprovada",
  ATENDIDA: "Atendida",
  CANCELADA: "Cancelada",
};
export const SITUACAO_REQ_TONE = {
  RASCUNHO: "neutral",
  APROVADA: "info",
  ATENDIDA: "success",
  CANCELADA: "danger",
};

export const SITUACAO_OC_LABEL = {
  ABERTA: "Aberta",
  PARCIAL: "Parcial",
  RECEBIDA: "Recebida",
  CANCELADA: "Cancelada",
};
export const SITUACAO_OC_TONE = {
  ABERTA: "info",
  PARCIAL: "warning",
  RECEBIDA: "success",
  CANCELADA: "danger",
};

export const TIPO_MOV_LABEL = {
  ENTRADA: "Entrada",
  SAIDA: "Saída",
  AJUSTE: "Ajuste",
};
export const TIPO_MOV_TONE = {
  ENTRADA: "success",
  SAIDA: "warning",
  AJUSTE: "neutral",
};

export const ORIGEM_MOV_LABEL = {
  MANUAL: "Manual",
  OC: "OC",
  PRODUCAO: "Produção",
  SOBRA: "Sobra",
  ALMOX: "Almoxarifado",
  INVENT: "Inventário",
  TRANSF: "Transferência",
};

export const CATEGORIAS = [
  { value: "FERRAGEM", label: "Ferragem" },
  { value: "PARAFUSO", label: "Parafuso" },
  { value: "COLA", label: "Cola/Adesivo" },
  { value: "FITA", label: "Fita" },
  { value: "BORDA", label: "Borda" },
  { value: "PINTURA", label: "Pintura" },
  { value: "EMBALAGEM", label: "Embalagem" },
  // Espelham o backend (estoque.models.CATEGORIAS) — chapa entra no nivel M2
  // do orcamento (ADR-0054) e modulo vem do import CAD.
  { value: "CHAPA", label: "Chapa (MDF/compensado)" },
  { value: "MODULO", label: "Módulo de marcenaria" },
  { value: "OUTRO", label: "Outro" },
];

export const UNIDADES = [
  { value: "UN", label: "UN" },
  { value: "PC", label: "PC" },
  { value: "CX", label: "CX" },
  { value: "KG", label: "KG" },
  { value: "G", label: "G" },
  { value: "M", label: "M" },
  { value: "M2", label: "M²" },
  { value: "M3", label: "M³" },
  { value: "L", label: "L" },
  { value: "ML", label: "ML" },
  { value: "PAR", label: "PAR" },
  { value: "RL", label: "RL" },
  { value: "CH", label: "CH (chapa inteira)" },
];

export function fmtMoeda(valor) {
  const n = Number(valor || 0);
  return n.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
}

export function fmtQtd(valor, casas = 3) {
  if (valor === null || valor === undefined || valor === "") return "—";
  const n = Number(valor);
  return n.toLocaleString("pt-BR", {
    minimumFractionDigits: 0,
    maximumFractionDigits: casas,
  });
}

export function fmtData(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString("pt-BR");
  } catch {
    return "—";
  }
}
